import { ReactNode } from 'react'

import { BreadCrumbButtonListContainer, BreadcrumItemButton } from './index.styles'

interface BreadCrumbButtonItemProps {
  icon?: ReactNode
  onClick?: () => void
  label: string
  isActive?: boolean
  id?: string
}

export const BreadCrumbButtonItem = ({ id, icon, onClick, label, isActive }: BreadCrumbButtonItemProps) => (
  <BreadcrumItemButton id={id} onClick={onClick} startIcon={icon} $isActive={isActive}>
    {label}
  </BreadcrumItemButton>
)

export type BreadCrumbButtonListItemProps = BreadCrumbButtonItemProps & {
  render?: (props: BreadCrumbButtonItemProps) => ReactNode
}

interface BreadCrumbButtonListProps {
  list: BreadCrumbButtonListItemProps[]
}

const BreadCrumbButtonList = ({ list }: BreadCrumbButtonListProps) => (
  <BreadCrumbButtonListContainer>
    {list.map(item =>
      item.render ? (
        item.render(item)
      ) : (
        <BreadCrumbButtonItem
          key={item.label}
          icon={item.icon}
          isActive={item.isActive}
          onClick={item.onClick}
          label={item.label}
        />
      ),
    )}
  </BreadCrumbButtonListContainer>
)

export default BreadCrumbButtonList
